import { useCallback } from 'react';

import { RootState } from '@/store';

import { useAppDispatch, useAppSelector } from '@/store/hooks/index';
import { SET_IS_JWT_LOADING } from '@/store/slices/pickem.slice';

export const useAuthStore = () => {
  const { isJwtLoading } = useAppSelector((state: RootState) => state.pickem);
  const dispatch = useAppDispatch();

  const setIsJwtLoading = useCallback(
    (data: boolean) => dispatch(SET_IS_JWT_LOADING(data)),
    [dispatch],
  );

  return { isJwtLoading, setIsJwtLoading };
};
